import { MaterialIcon, GraviButton } from '@gravitate-js/excalibrr'

interface CreditRebillButtonProps {
  onClick: () => void
  loading: boolean
}

export function CreditRebillButton({ onClick, loading }: CreditRebillButtonProps) {
  return (
    <GraviButton
      style={{ fontWeight: 'bold' }}
      buttonText='Credit / Rebill'
      icon={<MaterialIcon icon='currency_exchange' className='pt-1' />}
      onClick={onClick}
      loading={loading}
    />
  )
}
